import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  materialSeleccionado: any;
  selectedButton: string | null = 'Faltante';
  bgError: string = "";
  imagen: string = '';


  constructor(
    public dialogRef: MatDialogRef<ErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
console.log('✌️data --->', data);
    this.selectedButton = data.error || 'Faltante';

    if (data) {
      this.imagen = data.imgs&&data.imgs.length>0?data.imgs[0]:'';
    }

  }

  selectButton(button: string) {
    this.selectedButton = button;
  }

  resolve(action: string) {
    if (this.selectedButton) {
      this.dialogRef.close({ option: this.selectedButton, resolved: action });
    } else {
      this.dialogRef.close(null);
    }
  }
}
